export enum ActivityMemberEnum {
  ORGANIZER = 'ORGANIZER',
  LEADER = 'LEADER'
}

export const activityMemberEnumMapping: Record<ActivityMemberEnum, string> = {
  [ActivityMemberEnum.ORGANIZER]: 'Organizer',
  [ActivityMemberEnum.LEADER]: 'Leader'
}
